<template >
  <div class="itemContainer">
    
    <span class="item" >{{ item }}</span>
  </div>
</template>

<script>
export default {
  props: {
    item: { required: true },
  }
}
</script>
<style >
.item{
    
    color:wheat;
}
.itemContainer{
   background-color:black;
   width: 20rem;
}
</style>

